import { InsuranceProviderCard } from './components/InsuranceProviderCard/InsuranceProviderCard';
import { NotesCard } from './components/NotesCard/NotesCard';
import { OfficeInformationCard } from './components/OfficeInformationCard/OfficeInformationCard';
import { OfficeProfileCard } from './components/OfficeProfileCard/OfficeProfileCard';
import { ParkingCard } from './components/ParkingCard/ParkingCard';
import { SoftwareCard } from './components/SoftwareCard/SoftwareCard';

export const STEPS = [
  { name: 'Office Profile', Component: OfficeProfileCard },
  { name: 'Office Information', Component: OfficeInformationCard },
  { name: 'Insurance Provider', Component: InsuranceProviderCard },
  { name: 'Software', Component: SoftwareCard },
  { name: 'Parking', Component: ParkingCard },
  { name: 'Notes', Component: NotesCard },
];

// Whether a required field passes the save gate.
// Pre-existing missing values don't block saving unrelated edits — only fields
// the user actually touched (RHF dirtyFields) must be filled to allow Save.
export const requiredOk = (isDirty, isFilled) => !isDirty || !!isFilled;

const CURRENCY_REGEX = /^\d+(\.\d{0,2})?$/;

export const parseCurrencyInput = (rawValue) => {
  const value = rawValue?.replace('US$ ', '');
  if (CURRENCY_REGEX.test(value) || value === '') return value;
  return null;
};

export const formatCurrencyDisplay = (value) =>
  value ? `US$ ${value}` : '';
